module.exports = __webpack_public_path__ + "18c7e39f087e9bea7a09f23c0be26a89.svg";